import { tv } from 'tailwind-variants';

export const fontStyles = tv({
  base: ['text-token-gray-1600'],
  variants: {
    variant: {
      H1: ['font-heading', 'font-semibold', 'text-[64px]'],
      H2: ['font-heading', 'font-bold', 'text-[36px]', 'leading-[36px]'],
      H3: ['font-body', 'font-medium', 'text-[30px]', 'leading-[36px]'],
      H4: ['font-body', 'text-[24px]', 'leading-[29px]', 'font-semibold'],
      H5: ['font-body', 'text-[18px]', 'leading-[22px]', 'font-semibold'],
      H6: ['font-body', 'text-[16px]', 'leading-[20px]', 'font-semibold'],
      BODY_SM: ['font-body', 'text-[13px]', 'leading-[18px]', 'font-normal'],
      BODY_MD: ['font-body', 'text-[14px]', 'leading-[22px]', 'font-normal'],
      BODY_LG: ['font-body', 'text-[16px]', 'leading-[25px]', 'font-normal'],
      BODY_XL: ['font-body', 'text-[20px]', 'leading-[26px]', 'font-normal'],
      LABEL_XS: ['font-body', 'font-medium', 'text-[11px]', 'leading-[14px]'],
      LABEL_SM: ['font-body', 'font-medium', 'text-[13px]', 'leading-[16px]'],
      LABEL_MD: ['font-body', 'font-medium', 'text-[14px]', 'leading-[16px]'],
      LABEL_LG: ['font-body', 'font-medium', 'text-[16px]', 'leading-[16px]'],
      CAPTION: ['font-body', 'font-normal', 'text-[12px]', 'leading-[15px]'],
    },
  },
});
